










































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { fetchSMS } from '@/pantallas/TorreControl/fetchSMS';
import '../ClassAggridSMS.css';
import Confirmation from '@/components/Confirmation.vue';
import CreacionDeGpsSim from '@/pantallas/TorreControl/EnvioComandosSMS/CreacionDeGpsSim.vue';

@Component({
  components: {
    CreacionDeGpsSim,
    CabeceraModal,
    AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class EnvioComandosModal extends Vue {
  @Prop({ default: false }) show: boolean;
  @Prop({
    default: {
      patente: '[Sin patente seleccionada]',
      id_marca: '',
      id_modelo: '',
      marca: '',
      modelo: '',
    },
  })
  params: any;
  @Prop({ default: '' }) modalType: string;
  @Prop({ default: '' }) errorConfigVehicle: string;

  loadingService = new LoadingService();
  //@ts-ignore
  $snotify: any;
  titleModal: string = '';
  current_command: any = {};
  searchCommand: string = '';
  titleConfirmSend: string = '';
  messageConfirmSend: string = '';
  dialogConfirmSend: boolean = false;
  dialogConfirmSendDefault: boolean = false;
  columnApi: any = null;
  gridApi: GridApi = null;
  typeCommands: any[] = ['Reinicio'];
  defaultCommandType: string = '';
  dialog: boolean = false;
  isTrack3: boolean = false;
  sendColumns: ColDef[] = [
    {
      headerName: 'id',
      field: 'id',
      hide: true,
    },
    {
      headerName: 'Marca',
      field: 'marca',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Modelo',
      field: 'modelo',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Tipo de comando',
      field: 'tipo_comando',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Descripción',
      field: 'descripcion',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Comando',
      field: 'comando',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Usuario Creador',
      field: 'usuariocreadorid',
      sortable: true,
      resizable: true,
      minWidth: 80,
      hide: true,
    },
    {
      headerName: 'Fecha De Creación',
      field: 'fechacreacion',
      sortable: true,
      resizable: true,
      minWidth: 80,
      hide: true,
    },
    {
      headerName: 'Último Usuario Modificador',
      field: 'usuariomodificacionid',
      sortable: true,
      resizable: true,
      minWidth: 80,
      hide: true,
    },
    {
      headerName: 'última Fecha Modificación',
      field: 'fechamodificacion',
      sortable: true,
      resizable: true,
      minWidth: 80,
      hide: true,
    },
    {
      headerName: 'Enviar',
      sortable: false,
      resizable: false,
      width: 100,
      minWidth: 100,
      suppressAutoSize: true,
      suppressSizeToFit: true,
      pinned: 'right',
      onCellClicked: this.handleSendCommand,
      cellRenderer: (params: any) => {
        return '<i class="material-icons" id="iSMS" title="Enviar SMS" style="width: 28px; height: 28px; color: #27488e" >send</i>';
      },
      cellClass: 'cellClassSendAggrid',
    },
  ];
  detailColumns: ColDef[] = [
    {
      headerName: 'id',
      field: 'id',
      hide: true,
    },
    {
      headerName: 'Fecha de Envío',
      field: 'fecha_envio',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Comando',
      field: 'comando',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Usuario',
      field: 'usuario',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Estado de Recepción',
      field: 'estado_rcp_sms',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Fecha de Recepción',
      field: 'fecha_rcp_sms',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Tipo de Envío',
      field: 'tipo_envio',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
    {
      headerName: 'Proceso de Envío',
      field: 'proceso_envio',
      sortable: true,
      resizable: true,
      minWidth: 80,
    },
  ];
  gridOptions: GridOptions = {
    columnDefs: [],
    pagination: true,
    paginationPageSize: 50,
    cacheBlockSize: 10000,
    paginationAutoPageSize: false,
    onGridReady: this.handleGridReady,
    overlayNoRowsTemplate: '',
    suppressCsvExport: false,
    onGridSizeChanged: (event: any) => {
      event.api.sizeColumnsToFit();
    },
  };

  handleCerrar() {
    this.$emit('cerrar');
  }

  handleSendCommand(event: any) {
    this.current_command = event.data;
    this.titleConfirmSend = `Enviar comando ${event.data.tipo_comando}`;
    this.messageConfirmSend = `¿Desea enviar el comando ${event.data.comando} al vehículo ${this.params.patente}?`;
    this.dialogConfirmSend = true;
  }

  @Watch('show', { immediate: true })
  async onOpenDialog() {
    if (this.show) {
      var self = this;
      this.switchModalType(
        this.modalType,
        () => {
          self.titleModal = 'Detalles de envío: ';
          self.gridOptions.overlayNoRowsTemplate =
            'No hay ningún envío registrado para este vehículo';
          self.gridOptions.api.setColumnDefs(this.detailColumns);
          self.gridApi.setRowData([]);
          self.getDetails();
        },
        () => {
          self.titleModal = 'Envío de comandos: ';
          self.gridOptions.overlayNoRowsTemplate =
            'No hay comandos disponibles para el modelo del vehículo';
          self.gridOptions.api.setColumnDefs(this.sendColumns);
          self.gridApi.setRowData([]);
          self.getCommands();
        }
      );
    } else {
      this.gridApi.setRowData([]);
    }
  }

  onHandleSendDefaultCommand() {
    if (this.defaultCommandType == '' || this.defaultCommandType == null) {
      this.$snotify.error('Seleccione un tipo de comando para el envío');
      return;
    }

    this.titleConfirmSend = `Enviar comandos de tipo ${this.defaultCommandType}`;
    this.messageConfirmSend = `¿Desea enviar los comandos de tipo ${this.defaultCommandType} al vehículo ${this.params.patente}?`;
    this.dialogConfirmSendDefault = true;
  }

  switchModalType(
    type: string,
    detailFunction: Function,
    sendFunction: Function
  ) {
    switch (type) {
      case 'detail':
        detailFunction();
        break;
      case 'send':
        sendFunction();
        break;
    }
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }

  sendItemCallback(confirm: boolean) {
    this.dialogConfirmSend = false;
    if (confirm) {
      this.sendCommand();
    }
  }
  sendItemCallbackDefault(confirm: boolean) {
    this.dialogConfirmSendDefault = false;
    if (confirm) {
      this.sendDefaultCommand();
    }
  }

  sendDefaultCommand() {
    this.loadingService.showLoading();
    const body: any = {
      patente: this.params.patente,
      tipo_comando: this.defaultCommandType,
      id_usuario: this.getUserID().toString(),
      id_cliente: this.getClientID().toString(),
    };

    fetchSMS(body, 'send_default_command')
      .then((response: any) => {
        if (
          !response.data.hasOwnProperty('CODIGO_RESPUESTA') ||
          response.data.CODIGO_RESPUESTA != '1'
        ) {
          if (
            response.data.MENSAJE_RESPUESTA ==
            'La patente no registra número de sim'
          ) {
            this.dialog = true;
            this.isTrack3 = response.data.avl == 'TRACK3';
            this.$snotify.warning(response.data.MENSAJE_RESPUESTA);
            this.$snotify.warning('Completa el formulario para continuar');
          } else {
            this.$snotify.error(
              response.data.hasOwnProperty('MENSAJE_RESPUESTA')
                ? response.data.MENSAJE_RESPUESTA
                : '[1] Error al enviar los comandos al vehículo'
            );
          }
        } else {
          this.$snotify.success(
            'Se ha generado con éxito el proceso para los envíos'
          );
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error(
          'Error al obtener la respuesta del envío de comandos [send_command]'
        );
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  getCommandsType() {
    this.loadingService.showLoading();
    fetchSMS({}, 'get_commands_type')
      .then((response: any) => {
        if (
          !response.data.hasOwnProperty('CODIGO_RESPUESTA') ||
          response.data.CODIGO_RESPUESTA != '1'
        ) {
          this.$snotify.error(
            response.data.hasOwnProperty('MENSAJE_RESPUESTA')
              ? response.data.MENSAJE_RESPUESTA
              : '[1] Error al obtener los tipos de comando'
          );
        } else {
          this.typeCommands = response.data.data;
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error(
          'Error al obtener la respuesta de los tipos de comando [get_commands_type]'
        );
      })
      .finally(() => {
        this.gridApi.setDomLayout('autoHeight');
        this.loadingService.hideLoading();
      });
  }

  getDetails() {
    this.loadingService.showLoading();
    const body = {
      fecha_inicio: '',
      fecha_fin: '',
      tipo_envio: '',
      patente: this.params.patente,
      id_cliente: '',
    };
    fetchSMS(body, 'get_sent_command')
      .then((response: any) => {
        if (
          !response.data.hasOwnProperty('CODIGO_RESPUESTA') ||
          response.data.CODIGO_RESPUESTA != '1'
        ) {
          this.$snotify.error(
            response.data.hasOwnProperty('MENSAJE_RESPUESTA')
              ? response.data.MENSAJE_RESPUESTA
              : '[1] Error al obtener los comandos envíados'
          );
        } else {
          this.gridApi.setRowData(response.data.data);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error(
          'Error al obtener la respuesta de los comandos envíados [get_sent_command]'
        );
      })
      .finally(() => {
        this.gridApi.setDomLayout('autoHeight');
        this.loadingService.hideLoading();
      });
    this.loadingService.hideLoading();
  }

  sendCommand() {
    let self = this;
    this.loadingService.showLoading();
    const body: any = {
      patente: this.params.patente,
      id_comando: this.current_command.id,
      id_usuario: this.getUserID().toString(),
      id_cliente: this.getClientID().toString(),
    };
    fetchSMS(body, 'send_command')
      .then((response: any) => {
        if (
          !response.data.hasOwnProperty('CODIGO_RESPUESTA') ||
          response.data.CODIGO_RESPUESTA != '1'
        ) {
          if (
            response.data.MENSAJE_RESPUESTA ==
            'La patente no registra número de sim'
          ) {
            this.dialog = true;
            this.isTrack3 = response.data.avl == 'TRACK3';
            this.$snotify.warning(response.data.MENSAJE_RESPUESTA);
            this.$snotify.warning('Completa el formulario para continuar');
          } else {
            this.$snotify.error(
              response.data.hasOwnProperty('MENSAJE_RESPUESTA')
                ? response.data.MENSAJE_RESPUESTA
                : '[1] Error al enviar los comandos al vehículo'
            );
          }
          /*this.$snotify.error(
            response.data.hasOwnProperty('MENSAJE_RESPUESTA')
              ? response.data.MENSAJE_RESPUESTA
              : '[1] Error al enviar el comando al vehículo'
          );*/
        } else {
          this.$snotify.success('Se ha enviado el comando con éxito');
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error(
          'Error al obtener la respuesta del envío de comando [send_command]'
        );
      })
      .finally(() => {
        this.gridApi.setDomLayout('autoHeight');
        this.loadingService.hideLoading();
      });
  }

  mounted() {
    this.getCommandsType();
  }

  async getCommands() {
    this.loadingService.showLoading();
    fetchSMS(
      {
        marca: this.params.marca,
        modelo: this.params.modelo,
        id_cliente: this.getClientID().toString(),
        id_usuario: this.getUserID().toString(),
        tipo_envio: 'sms',
      },
      'get_command'
    )
      .then((response: any) => {
        if (
          !response.data.hasOwnProperty('CODIGO_RESPUESTA') ||
          response.data.CODIGO_RESPUESTA != '1'
        ) {
          this.$snotify.error(
            response.data.hasOwnProperty('MENSAJE_RESPUESTA')
              ? response.data.MENSAJE_RESPUESTA
              : '[1] Error al obtener los comandos'
          );
        } else {
          this.gridApi.setRowData(response.data.data);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error(
          'Error al obtener la respuesta de los comandos [get_command]'
        );
      })
      .finally(() => {
        this.gridApi.setDomLayout('autoHeight');
        this.loadingService.hideLoading();
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
    // return 5216;
  }

  async handleCierreModalCrear() {
    this.dialog = false;
  }
}
